import FastImage from 'react-native-fast-image';
import LinearGradient from 'react-native-linear-gradient';
import {RFValue} from 'react-native-responsive-fontsize';
import styled from 'styled-components/native';
import MaterialCommunityIcons from 'react-native-vector-icons/MaterialCommunityIcons';

export const SectionTitleRow = styled.View`
  flex-direction: row;
  align-items: center;
  gap: ${RFValue(8)}px;
`;

export const CrownWrapper = styled.View`
  background-color: rgba(212, 175, 55, 0.12);
  border-radius: ${RFValue(20)}px;
  padding: ${RFValue(6)}px;
  justify-content: center;
  align-items: center;
`;

export const CrownIcon = styled(MaterialCommunityIcons).attrs({
  name: 'crown',
  size: RFValue(20),
  color: '#C89B1F',
})``;

export const ArrowIcon = styled(MaterialCommunityIcons).attrs({
  name: 'arrow-right',
  size: RFValue(16),
})`
  color: ${({theme}) => theme.colors.title};
`;


export const Container = styled.View`
  flex: 1;
  background-color: ${({theme}) => theme.colors.background};
`;

export const SectionHeader = styled.View`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${RFValue(16)}px;
`;

export const TitleColumn = styled.View``;

export const Subtitle = styled.Text`
  font-family: ${({theme}) => theme.fonts.regular};
  font-size: ${RFValue(10)}px;
  color: ${({theme}) => theme.colors.title};
`;
export const ContainerGradient = styled(LinearGradient)`
  padding-top: ${RFValue(12)}px;
`;

export const ClubeCarousel = styled.View`
  margin-top: ${RFValue(12)}px;
`;

export const SectionTouchable = styled.TouchableOpacity``;

export const SectionContainer = styled.View`
  margin: 0 24px;
`;

export const StoreListContainer = styled.View`
  margin: 0 14px;
  margin-bottom: ${RFValue(12)}px;
`;

export const Title = styled.Text`
  color: ${({theme}) => theme.colors.title};
  font-size: ${RFValue(13)}px;
  font-family: ${({theme}) => theme.fonts.bold};
`;

export const StoreGridContainer = styled.View`
  margin: ${RFValue(12)}px 14px 0 14px;
`;

export const CustomPanel = styled.TouchableOpacity`
  flex: 1;
  margin: 0 12px;
`;

export const PanelImage = styled(FastImage)`
  width: 100%;
  aspect-ratio: 4.2;
`;

export const ClubeActionButton = styled.TouchableOpacity``;

export const ClubeActionContainer = styled(LinearGradient)`
  height: ${RFValue(35)}px;
  justify-content: center;
  align-items: center;
  margin: 0 24px;
  border-radius: ${RFValue(18)}px;
  border-color: ${({theme}) => theme.colors.purple_2_border};
  border-style: solid;
  border-width: 2px;
`;

export const ClubeActionButtonText = styled.Text`
  color: ${({theme}) => theme.colors.shape};
  font-size: ${RFValue(12)}px;
  font-family: ${({theme}) => theme.fonts.semibold};
`;
